import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sun = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.99984 12.3333C10.3931 12.3333 12.3332 10.3932 12.3332 7.99999C12.3332 5.60676 10.3931 3.66666 7.99984 3.66666C5.6066 3.66666 3.6665 5.60676 3.6665 7.99999C3.6665 10.3932 5.6066 12.3333 7.99984 12.3333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7602 12.76L12.6735 12.6733M12.6735 3.32668L12.7602 3.24001L12.6735 3.32668ZM3.24016 12.76L3.32683 12.6733L3.24016 12.76ZM8.00016 1.38668V1.33334V1.38668ZM8.00016 14.6667V14.6133V14.6667ZM1.38683 8.00001H1.3335H1.38683ZM14.6668 8.00001H14.6135H14.6668ZM3.32683 3.32668L3.24016 3.24001L3.32683 3.32668Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Sun.displayName = 'Sun';
